module.exports = __webpack_public_path__ + "eaf1ac5148f95cba21a86442c617323b.svg";